import { configureStore } from "@reduxjs/toolkit";
import rootReducer from '../redux'

const middlewares: any = [];

export default configureStore({reducer: rootReducer})